import {Context} from '@acng/frontend-relativity';

/**
 * @type {Local<Challenge>}
 */
export const ctxChallenge = Context();
